import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=d91926e4&"
import script from "./CategoryTable.vue?vue&type=script&lang=js&"
export * from "./CategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports